module.exports = __webpack_public_path__ + "img/Whales.87bfedb0.svg";